module.exports = __webpack_public_path__ + "ig-rating.838bb40f0914546c54be.png";


//////////////////
// WEBPACK FOOTER
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/assets/img/ig-rating.png
// module id = ../../../../../client/assets/img/ig-rating.png
// module chunks = styles